import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import DropdownTableCellEdit from 'components/organisms/TableCellEdits/DropdownTableCellEdit/DropdownTableCellEdit';

const StyledTimelineTableCellEdit = styled(DropdownTableCellEdit)`
  &.TimelineTableCellEdit {
    width: ${props => props.theme.layout(500)};
    height: min(${props => props.theme.layout(440)}, 46vh);
  }
  
  .TimelinePanel-feed {
    .DataList-list {
      padding: ${props => props.theme.spacing(2)};
    }
  }
  
  ${props => props.theme.breakpoints.down('xl')} {
    &.TimelineTableCellEdit {
      width: ${props => props.theme.layout(440)};
      height: min(${props => props.theme.layout(400)}, 46vh);
    }
  }
  
  ${props => props.theme.breakpoints.down('lg')} {
    &.TimelineTableCellEdit {
      width: ${props => props.theme.layout(380)};
      height: min(${props => props.theme.layout(340)}, 46vh);
    }
  }
  
  ${ComponentStyles}
`;

StyledTimelineTableCellEdit.propTypes = {
  theme: PropTypes.object
};

export default StyledTimelineTableCellEdit;
